<action-button
        [buttonLabel]="uploadButtonLabel"
        actionInProgressLabel="uploadFormButtonInProgressLabel"
        buttonType="button"
        [actionInProgress]="uploadInProgress$ | async"
        [buttonDisabled]="(codeCheckInProgress$ | async) || measurementCodeExists"
        (buttonClick)="uploadClick.emit()"
        [testId]="'submit-button'">
</action-button>

<span
        data-testid="submit-error-message"
        *ngIf="!!errorMessage"
        class="alert alert-danger ms-2">
        {{ errorMessage | localize }}
</span>

<span
        data-testid="submit-warning-message"
        *ngIf="!!warningMessage"
        class="alert alert-warning ms-2">
        {{ warningMessage }}
</span>
